export interface WorkflowInstance {
  nodeId: string;
  startedAt: string;
  workflowId: string;
  schedule: string;
  finishedAt: string;
}

export enum CustomerCaseListWorkflowOperationFilter {
  InCampaign = 'IN_CAMPAIGN',
  NotInCampaign = 'NOT_IN_CAMPAIGN',
  HasBeenInCampaign = 'HAS_BEEN_IN_CAMPAIGN',
  HasNotBeenInCampaign = 'HAS_NOT_BEEN_IN_CAMPAIGN',
}
